/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/requests.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Shared agent function for basic API usage.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 5:05 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

import { API_ROOT, API_ROOT_LAMBDA } from '../constants/actionTypes';

const superagent = superagentPromise(_superagent, global.Promise);

const responseBody = res => res.body;

let token = null;

const tokenPlugin = req => {
  if (token) {
    req.set('authorization', `Bearer ${token}`);
  }
}

export const requests = {
  del: (url) =>
    superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  get: (url, body) => superagent.get(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  put: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  setToken: _token => { token = _token },
  postLambda: (url, body) => superagent.post(`${API_ROOT_LAMBDA}${url}`, body).use(tokenPlugin).then(responseBody),
};